import request from 'sb-request'
import actions from 'redux/actions'
import { reducers } from 'redux/core'


const fetchUndeliveredOrders = () =>
  request.post('graphql?name=pendingSubscriptionOrders', {
    body: {
      query: `{
        data: pendingSubscriptionOrders {
          isOrderInfoVisible
          hasEmptyProductsForNextMonth
          orders {
            year
            month
            shippingDate
            tracking {
              id
              trackingNumber
              trackingUrl
              shipmentDate
              status
            }
            products {
              id
              image: img
              url
              name
              brand
              isSurprise
              upchargePrice
              isAddedAutomatically
              isFragranceOfTheMonth
            }
          }
        }
      }`,
    },
    modifyResult: ({ data = {} }) => data,
  })
    .then(
      (data) => reducers.view.trackingPage.setShipment(data),
      () => {
        reducers.view.trackingPage.setFetched()
      }
    )

const fetchRecommendations = ({ gender }) => {
  reducers.view.trackingPage.setProductsFetching(true)

  actions.models.products.fetchRecommendations({ gender })
    .then(
      (products) => reducers.view.trackingPage.setProducts(products),
      () => reducers.view.trackingPage.setProductsFetching(false)
    )
}

const fetchPopularByGender = ({ gender, limit }) => {
  reducers.view.trackingPage.setProductsFetching(true)

  actions.models.products.fetchPopularByGender({ gender, limit })
    .then(
      (products) => {
        reducers.view.trackingPage.setProducts(products)
      },
      () => {
        reducers.view.trackingPage.setProductsFetching(false)
      }
    )
}

export default {
  fetchUndeliveredOrders,
  fetchRecommendations,
  fetchPopularByGender,
}
